import { render, staticRenderFns } from "./FollowUps.vue?vue&type=template&id=12c357ad&scoped=true"
import script from "./FollowUps.vue?vue&type=script&lang=ts"
export * from "./FollowUps.vue?vue&type=script&lang=ts"
import style0 from "./FollowUps.vue?vue&type=style&index=0&id=12c357ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c357ad",
  null
  
)

export default component.exports